import {
  DEFAULT_CURATED_BG_COLOR,
  DEFAULT_CURATED_TEXT_COLOR,
  type ICuratedItem,
} from './curated'
import { type ITopicContentItem } from './topicContents'

import type { IMycleContentCard, IMycleContentSeriesItem } from '../model/home'

/** API 시리즈 카드 → CuratedSwiperSection 의 스키마(ICuratedItem) 로 매핑 */
export const toCuratedItem = (item: IMycleContentSeriesItem): ICuratedItem => ({
  id: item.serverId,
  imageUrl: item.thumbnailUrl,
  title: item.title,
  backgroundColor: item.series.bgColor ?? DEFAULT_CURATED_BG_COLOR,
  titleColor: item.series.textColor ?? DEFAULT_CURATED_TEXT_COLOR,
})

/** API 콘텐츠 카드 → TopicContentsSection 의 스키마(ITopicContentItem) 로 매핑 */
export const toTopicContentItem = (
  card: IMycleContentCard
): ITopicContentItem => ({
  id: card.serverId,
  imageUrl: card.thumbnailUrl,
  title: card.title,
})
